import { LoadingOutlined } from '@ant-design/icons';

interface Props {
  pullDistance: number;
  isRefreshing: boolean;
  progress: number;
}

export default function PullToRefreshIndicator({ pullDistance, isRefreshing, progress }: Props) {
  const visible = pullDistance > 0 || isRefreshing;
  if (!visible) return null;

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: Math.max(pullDistance, isRefreshing ? 48 : 0),
        transition: isRefreshing ? 'height 0.2s ease' : 'none',
        overflow: 'hidden',
        zIndex: 20,
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          background: 'var(--bl-surface, #fff)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: isRefreshing ? 1 : progress,
          transform: `scale(${0.6 + progress * 0.4})`,
          transition: isRefreshing ? 'opacity 0.15s, transform 0.15s' : 'none',
        }}
      >
        {isRefreshing ? (
          <LoadingOutlined style={{ fontSize: 16, color: 'var(--bl-accent, #3390ec)' }} spin />
        ) : (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            style={{
              color: 'var(--bl-accent, #3390ec)',
              transform: `rotate(${progress * 180}deg)`,
              transition: 'none',
            }}
          >
            <path
              d="M8 1v6M8 1L5 4M8 1l3 3M3 8a5 5 0 1 0 10 0"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
        )}
      </div>
    </div>
  );
}
